// extracted by mini-css-extract-plugin
export default {"settingsMain":"settings_settingsMain__UPXzx","settingsListWrapper":"settings_settingsListWrapper__FBFX4"};